import { APP_INITIALIZER } from '@angular/core';
import { RoutesService, eLayoutType } from '@abp/ng.core';
import { eThemeSharedRouteNames } from '@abp/ng.theme.shared';

export const CURADORIA_OFERTAS_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/curadoria-ofertas',
        name: 'Curadoria de ofertas',
        iconClass: 'fas fa-history',
        order: 104,
        layout: eLayoutType.application,
        parentName: eThemeSharedRouteNames.Administration,
        // Permissão só do host (MultiTenancySides.Host): tenant nunca vê este item.
        requiredPolicy: 'cargo_fleet.CuradoriaOfertas.Host',
      },
    ]);
  };
}
